import FileName from '../ComControl/FileName'
import Viewport from '../ComControl/Viewport'
import AvgButtonIndex from '../ComControl/AvgButtonIndex'
import AvgButton from '../ComControl/AvgButton'
import { FileReader, FileWriter } from '@/platform'
class SaveLoadData {
    /**
     * 是否显示剧情名称
     */
    public IsMapName: boolean = false
    /**
     * 是否显示日期
     */
    public IsDate: boolean = false
    /**
     * 背景图
     */
    public BackPic: FileName = new FileName({ type: FileName.DEF_TYPE, name: '' })
    /**
     * 显示区域
     */
    public Viewport: Viewport = new Viewport()
    /**
     * 存档最大数
     */
    public Max: number = 0
    /**
     * 分几列
     */
    public Column: number = 0
    /**
     * 行间距
     */
    public SpanRow: number = 0
    /**
     * 列间距
     */
    public SpanCol: number = 0
    /**
     * 返回按钮索引
     */
    public BackButtonEx: AvgButtonIndex = new AvgButtonIndex()
    /**
     * 关闭按钮索引
     */
    public CloseButtonEx: AvgButtonIndex = new AvgButtonIndex()
    /**
     * 选择相应的按钮  project_bin_no
     */
    public BackButton: AvgButton = new AvgButton()
    /**
     * 关闭窗口的按钮   project_bin_no
     */
    public CloseButton: AvgButton = new AvgButton()
    /**
     * 是否显示缩略图
     */
    public IsMinPic: boolean = false
    /**
     * 剧情名称的X坐标
     */
    public Name_X: number = 0
    /**
     * 剧情名称的Y坐标
     */
    public Name_Y: number = 0
    /**
     * 时间的X坐标
     */
    public Date_X: number = 0
    /**
     * 时间的Y坐标
     */
    public Date_Y: number = 0
    /**
     * 缩略图的X坐标
     */
    public Pic_X: number = 0
    /**
     * 缩略图的Y坐标
     */
    public Pic_Y: number = 0
    /**
     * 缩略图的缩放率
     */
    public Zoom: number = 0
    /**
     * 按钮的索引
     */
    public BtnIndex: number[] = []
    /**
     * 是否支持翻页
     */
    public IsPage: number = 0
    /**
     * 上一页
     */
    public PrePic: AvgButtonIndex = new AvgButtonIndex()
    /**
     * 下一页
     */
    public NextPic: AvgButtonIndex = new AvgButtonIndex()
    /**
     * 页码X坐标
     */
    public PageX: number = 0
    /**
     * 页码Y坐标
     */
    public PageY: number = 0
    /**
     * 存档字体名称
     */
    public CundangFontName: string = ''
    /**
     * 存档字体大小
     */
    public CundangFontSize: number = 0

    constructor(btns?: AvgButton[], dataversion?: number) {
        if (Array.isArray(btns)) {
            this.IsMapName = true
            this.IsDate = true
            this.IsMinPic = true
            this.BackPic = new FileName({ type: FileName.DEF_TYPE, name: 'save.png' })
            this.Viewport = new Viewport(20, 100, 742, 367)
            this.Max = 10
            this.Column = 5
            this.SpanRow = 185
            this.SpanCol = 150
            this.BackButton = btns[0]!
            this.CloseButton = btns[1]!
            this.Name_X = 15
            this.Name_Y = 10
            this.Date_X = 5
            this.Date_Y = 40
            this.Pic_X = 1
            this.Pic_Y = 70
            this.Zoom = 19
            this.BtnIndex = [22, 15]
            this.BackButtonEx = new AvgButtonIndex(22, this.BackButton?.X, this.BackButton?.Y)
            this.CloseButtonEx = new AvgButtonIndex(15, this.CloseButton?.X, this.CloseButton?.Y)

            this.IsPage = 0
            this.PrePic = new AvgButtonIndex()
            this.NextPic = new AvgButtonIndex()
            this.PageX = 0
            this.PageY = 0
            this.CundangFontName = '宋体'
            this.CundangFontSize = 32
        } else {
            // TODO 读取数据
        }
    }

    /** 与 cg_v3_data SaveLoadData @DataStrucrParse 序号 1～28 一致（BaseDataStructure：boolean 用 readBool/writeBool） */
    readBin(reader: FileReader): void {
        this.IsMapName = reader.readBool()
        this.IsDate = reader.readBool()
        this.BackPic = new FileName(reader)

        this.Viewport = new Viewport()
        this.Viewport.readBin(reader)

        this.Max = reader.readInt()
        this.Column = reader.readInt()
        this.SpanRow = reader.readInt()
        this.SpanCol = reader.readInt()

        this.BackButtonEx = new AvgButtonIndex()
        this.BackButtonEx.readBin(reader)
        this.CloseButtonEx = new AvgButtonIndex()
        this.CloseButtonEx.readBin(reader)

        this.BackButton = new AvgButton()
        this.BackButton.readBin(reader)
        this.CloseButton = new AvgButton()
        this.CloseButton.readBin(reader)

        this.IsMinPic = reader.readBool()

        this.Name_X = reader.readInt()
        this.Name_Y = reader.readInt()
        this.Date_X = reader.readInt()
        this.Date_Y = reader.readInt()
        this.Pic_X = reader.readInt()
        this.Pic_Y = reader.readInt()
        this.Zoom = reader.readInt()

        const btnN = reader.readInt()
        this.BtnIndex = []
        for (let i = 0; i < btnN; i++) {
            this.BtnIndex.push(reader.readInt())
        }

        this.IsPage = reader.readInt()

        this.PrePic = new AvgButtonIndex()
        this.PrePic.readBin(reader)
        this.NextPic = new AvgButtonIndex()
        this.NextPic.readBin(reader)

        this.PageX = reader.readInt()
        this.PageY = reader.readInt()
        this.CundangFontName = reader.readString()
        this.CundangFontSize = reader.readInt()
    }

    writeBin(writer: FileWriter): void {
        writer.writeBool(this.IsMapName)
        writer.writeBool(this.IsDate)
        this.BackPic.writeBin(writer)
        this.Viewport.writeBin(writer)
        writer.writeInt(this.Max)
        writer.writeInt(this.Column)
        writer.writeInt(this.SpanRow)
        writer.writeInt(this.SpanCol)
        this.BackButtonEx.writeBin(writer)
        this.CloseButtonEx.writeBin(writer)
        this.BackButton.writeBin(writer)
        this.CloseButton.writeBin(writer)
        writer.writeBool(this.IsMinPic)
        writer.writeInt(this.Name_X)
        writer.writeInt(this.Name_Y)
        writer.writeInt(this.Date_X)
        writer.writeInt(this.Date_Y)
        writer.writeInt(this.Pic_X)
        writer.writeInt(this.Pic_Y)
        writer.writeInt(this.Zoom)
        writer.writeInt(this.BtnIndex.length)
        for (let i = 0; i < this.BtnIndex.length; i++) {
            writer.writeInt(this.BtnIndex[i]!)
        }
        writer.writeInt(this.IsPage)
        this.PrePic.writeBin(writer)
        this.NextPic.writeBin(writer)
        writer.writeInt(this.PageX)
        writer.writeInt(this.PageY)
        writer.writeString(this.CundangFontName)
        writer.writeInt(this.CundangFontSize)
    }

    readVersionedOui(reader: FileReader): void {
        this.IsMapName = reader.readInt() == 1 ? true : false
        this.IsDate = reader.readInt() == 1 ? true : false
        this.BackPic.readVersionedOui(reader.readObj(reader.readInt()))
        this.Max = reader.readInt()
        this.Column = reader.readInt()
        this.SpanRow = reader.readInt()
        this.SpanCol = reader.readInt()
        this.IsMinPic = reader.readInt() ? true : false
        this.Name_X = reader.readInt()
        this.Name_Y = reader.readInt()
        this.Date_X = reader.readInt()
        this.Date_Y = reader.readInt()
        this.Pic_X = reader.readInt()
        this.Pic_Y = reader.readInt()
        this.Zoom = reader.readInt()
        this.Viewport.readVersionedOui(reader.readObj(reader.readInt()))
        this.BackButtonEx.readVersionedOui(reader.readObj(reader.readInt()))
        this.CloseButtonEx.readVersionedOui(reader.readObj(reader.readInt()))
        this.IsPage = reader.readInt()
        this.PrePic.readVersionedOui(reader.readObj(reader.readInt()))
        this.NextPic.readVersionedOui(reader.readObj(reader.readInt()))
        this.PageX = reader.readInt()
        this.PageY = reader.readInt()
        this.CundangFontName = reader.readString()
        this.CundangFontSize = reader.readInt()
    }

    writeVersionedOui(writer: FileWriter): void {
        writer.writerIntLength()

        writer.writeInt(this.IsMapName ? 1 : 0)
        writer.writeInt(this.IsDate ? 1 : 0)
        this.BackPic.writeVersionedOui(writer)
        writer.writeInt(this.Max)
        writer.writeInt(this.Column)
        writer.writeInt(this.SpanRow)
        writer.writeInt(this.SpanCol)
        writer.writeInt(this.IsMinPic ? 1 : 0)
        writer.writeInt(this.Name_X)
        writer.writeInt(this.Name_Y)
        writer.writeInt(this.Date_X)
        writer.writeInt(this.Date_Y)
        writer.writeInt(this.Pic_X)
        writer.writeInt(this.Pic_Y)
        writer.writeInt(this.Zoom)
        this.Viewport.writeVersionedOui(writer)
        this.BackButtonEx.writeVersionedOui(writer)
        this.CloseButtonEx.writeVersionedOui(writer)
        writer.writeInt(this.IsPage)
        this.PrePic.writeVersionedOui(writer)
        this.NextPic.writeVersionedOui(writer)
        writer.writeInt(this.PageX)
        writer.writeInt(this.PageY)
        writer.writeString(this.CundangFontName)
        writer.writeInt(this.CundangFontSize)

        writer.writerLength()
    }

    writeGameBin(writer: FileWriter): void {
        this.writeVersionedOui(writer)
    }
}
export default SaveLoadData
